//console.log("tiny-slider");

import { tns } from "tiny-slider";

// * TESTIMONIALS

const tnsRecensioni = document.querySelectorAll(".wrapper-testimonials");
tnsRecensioni.forEach((slider) => {
  const tnsSlider = tns({
    container: slider,
    items: 1,
    mouseDrag: true,
    swipeAngle: 30,
    autoplay: true,
    nav: true,
    loop: true,
    controls: false,
    autoplayButton: false,
    autoplayButtonOutput: false,
    controlsText: ["", ""],
  });
});

// * SLIDER ARTICOLI

const tnsSliderArticoli = document.querySelectorAll(".slider-articoli > div");
tnsSliderArticoli.forEach((slider) => {
  const tnsSlider = tns({
    container: slider,
    autoplayTimeout: 5000,
    center: false,
    items: 1,
    gutter: 0,
    autoplay: true,
    mouseDrag: true,
    //mode: "gallery",
    swipeAngle: 30,
    controls: true,
    nav: false,
    autoplayButton: false,
    autoplayButtonOutput: false,
    controlsText: ["", ""],
    lazyload: false,
    responsive: {
      480: {
        items: 1,
      },
      640: {
        items: 1,
      },
      768: {
        items: 2,
      },
      1280: {
        items: 3,
      },
    },
  });
});

// *

const tnsSliderGallery = document.querySelectorAll(".slider-gallery > div");
tnsSliderGallery.forEach((slider) => {
  const tnsSlider = tns({
    container: slider,
    autoplayTimeout: 5000,
    center: false,
    items: 1,
    gutter: 30,
    autoplay: true,
    mouseDrag: false,
    //mode: "gallery",
    swipeAngle: 30,
    controls: false,
    nav: true,
    autoplayButton: false,
    autoplayButtonOutput: false,
    controlsText: ["", ""],
    lazyload: true,
  });
});
